var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriveCardIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7671 2.68445H6.7378C6.20543 2.68445 5.69485 2.89593 5.3184 3.27238C4.94196 3.64883 4.73047 4.1594 4.73047 4.69178V20.7505C4.73047 21.2828 4.94196 21.7934 5.3184 22.1699C5.69485 22.5463 6.20543 22.7578 6.7378 22.7578H18.7818C19.3142 22.7578 19.8248 22.5463 20.2012 22.1699C20.5777 21.7934 20.7891 21.2828 20.7891 20.7505V8.70645L14.7671 2.68445Z",
    fill: "url(#paint0_linear_1197_13277)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70117 15.0629C7.70117 15.0629 9.54123 11.3828 12.7613 11.3828C15.9814 11.3828 17.8215 15.0629 17.8215 15.0629C17.8215 15.0629 15.9814 18.743 12.7613 18.743C9.54123 18.743 7.70117 15.0629 7.70117 15.0629Z",
    stroke: "url(#paint1_linear_1197_13277)",
    strokeWidth: 1.40513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7589 16.213C13.5211 16.213 14.139 15.5951 14.139 14.8329C14.139 14.0707 13.5211 13.4529 12.7589 13.4529C11.9968 13.4529 11.3789 14.0707 11.3789 14.8329C11.3789 15.5951 11.9968 16.213 12.7589 16.213Z",
    stroke: "url(#paint2_linear_1197_13277)",
    strokeWidth: 1.40513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1197_13277",
    x1: 12.7598,
    y1: 2.68445,
    x2: 20.7891,
    y2: 22.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6D5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7AFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1197_13277",
    x1: 12.7613,
    y1: 11.3828,
    x2: 12.7613,
    y2: 18.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A74FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1197_13277",
    x1: 12.7589,
    y1: 13.4529,
    x2: 12.7589,
    y2: 16.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A74FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveCardIcon5);
export default __webpack_public_path__ + "static/media/drive_card_icon5.53059904e0278e6e23d5606ab3da46ad.svg";
export { ForwardRef as ReactComponent };